module.exports = __webpack_public_path__ + "img/icon24.7104c52f.png";